export default __webpack_public_path__ + "static/media/PipeSupportWall.256.d58c68fb.png";